import { useTranslation } from "react-i18next";
import { Flex, Text } from "rebass/styled-components";
import { useRecoilValue } from "recoil";
import { useState } from "react";
import styled from "styled-components";

import { MatchHistoryMatchThumbnailState } from "MVVM/State/matchHistory";
import { TMoment } from "MVVM/Views/MatchHistory/@types";
import { MomentDetails } from "../MomentDetails";
import { Button } from "MVVM/Components/Button";
import { ESupportedGames } from "MVVM/@types";
import { analytics } from "MVVM/Analytics";
import {
  addAttributionParams,
  getAttributionUserId,
} from "MVVM/Utilities/Attribution";
import { useUser } from "MVVM/Hooks/useUser";

export const CreatedForFriend = ({
  game,
  moment,
  matchId,
}: {
  game: ESupportedGames;
  moment: TMoment;
  matchId: string;
}) => {
  const matchThumbnail = useRecoilValue(MatchHistoryMatchThumbnailState);
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const { allstarUser } = useUser();

  return (
    <Container>
      <ChampionBanner
        style={{
          backgroundImage: `linear-gradient(to bottom, transparent, var(--Gray-750, #1c2a34)), url(${matchThumbnail})`,
        }}
      />
      <MomentDetails moment={moment} />
      <Flex
        style={{ padding: "12px 24px 24px", gap: "12px" }}
        flexDirection="column"
        mb={7}
      >
        <Flex flexDirection="column" textAlign="center" style={{ gap: "12px" }}>
          <Text color="ice" variant="text.titleSmall">
            {t("createdForFriend.title", "Your friend's clip is on the way!")}
          </Text>
          <Text color="chalk" variant="text.paragraphMedium">
            {t(
              "createdForFriend.subtitle",
              "It will be ready in a few minutes. Click below to share it with your friend!",
            )}
          </Text>
        </Flex>
        {!copied ? (
          <Button
            className="primary"
            onClick={() => {
              const userId = getAttributionUserId(allstarUser);
              const baseUrl = `${window.location.origin}/match-history?matchId=${matchId}&playerSearchIdentifier=${moment.player.gameId}&game=${game}&utm_source=mh_sharing&momentId=${moment.id}`;
              const usersMatchHistory = addAttributionParams(baseUrl, userId);
              navigator.clipboard.writeText(usersMatchHistory);
              analytics.track("Button - Click", {
                location: "matchHistory",
                locationIdentifier: "shareMomentToFriend",
                source: "website",
              });
              setCopied(true);
            }}
            style={{ width: "50%", margin: "0 auto", marginTop: 24 }}
          >
            Share
          </Button>
        ) : (
          <Text
            color="envy"
            variant="text.paragraphMedium"
            style={{ margin: "0 auto", marginTop: 24 }}
          >
            Link Copied to Clipboard!
          </Text>
        )}
      </Flex>
    </Container>
  );
};

const Container = styled(Flex)`
  background-color: var(--Gray-750, #1c2a34);
  border-radius: 14px;
  border: ${({ theme }) => `1px solid ${theme.colors.envyAlpha20}`};
  box-shadow: ${({ theme }) => `0px 0px 16px 0px ${theme.colors.envyAlpha20}`};
  flex-direction: column;
  position: relative;
  text-align: center;
  width: 448px;
`;

const ChampionBanner = styled(Flex)`
  background-size: cover;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  height: 225px;
  width: 100%;
`;
